<mat-toolbar class="header">
  <button matIconButton (click)="drawer.toggle()" aria-label="Menu icon">
    @if (drawer.opened) {
      <mat-icon>arrow_back</mat-icon>
    } @else {
      <mat-icon>menu</mat-icon>
    }
  </button>

  <span class="title-header">{{ 'appName' | translate }}</span>
  <span class="spacer"></span>

  <button matIconButton class="theme-btn" (click)="themeService.toggleTheme()">
    <mat-icon>{{ themeService.darkMode() ? 'light_mode' : 'dark_mode'}}</mat-icon>
  </button>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="lang-select">
    <mat-select (selectionChange)="changeLanguage($event.value)" [value]="translateService.currentLang">
      @for (lang of languages; track lang.code) {
        <mat-option [value]="lang.code">{{ lang.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button matMiniFab [matMenuTriggerFor]="menu" color="secondary" class="profile-btn">
    <mat-icon class="profile-icon">account_circle</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="'/users/profile'" *appCanAccess="[permissionEnum.READ, windowsId.PROFILE]">
      {{ 'contentLayout.toolbar.profile' | translate }}
    </button>
    <button mat-menu-item (click)="logout()">{{ 'contentLayout.toolbar.logout' | translate }}</button>
  </mat-menu>
</mat-toolbar>

<mat-drawer-container class="nav-container" autosize>
  <mat-drawer #drawer class="sidenav" mode="side">
    @for (item of menuItems; track item.id) {
      @if (item.children && item.children.length > 0) {
        <mat-expansion-panel class="menu-list-item">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="menu-list-icon" fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
              {{ `common.menuOptions.${item.title.toLocaleLowerCase()}` | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="list-items">
              @for (child of item.children; track child.id) {
              <a matButton
                [routerLink]="child.route"
                class="list-menu-item">
                  <mat-icon fontSet="material-symbols-outlined">{{ child.icon }}</mat-icon>
                  {{ `common.menuOptions.${child.title.toLocaleLowerCase()}` | translate }}
              </a>
            }
            </div>
        </mat-expansion-panel>
      } @else {
        <a matButton [routerLink]="item.route" class="menu-item">
          <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
          <span>{{ `common.menuOptions.${item.title.toLocaleLowerCase()}` | translate }}</span>
        </a>
      }
    }

    <mat-action-row class="logout" (click)="logout()">
      <button matButton class="menu-item logout-btn">{{ 'contentLayout.sidenav.logout' | translate }}</button>
    </mat-action-row>
  </mat-drawer>

  <div class="sidenav-content">
    <div class="main-content-wrapper">
      <router-outlet />
    </div>

    <footer class="footer">
      <div class="footer-content">
        <span class="copyright">
          &copy; {{ year }} {{ 'appName' | translate }}
        </span>

        <span class="spacer"></span>

        <div class="footer-links">
          <span class="version-badge">v{{ systemVersion }}</span>
        </div>
      </div>
    </footer>
  </div>
</mat-drawer-container>
